<template>
    <div class="fullscreen-loader">
        <transition name="fade">
            <div
                v-if="showLoading"
                class="loader-container full-screen"
            >
                <loader-box />
            </div>
        </transition>
        <transition name="fade">
            <div
                v-show="!showLoading"
                class="flex-1 w-full h-full"
            >
                <slot />
            </div>
        </transition>
    </div>
</template>
<script>
import LoaderBox from 'common/UIToolKit/layout/LoaderBox.vue';

export default {
    components: {
        LoaderBox,
    },
    props: {
        showLoading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss">
    @import "common/scss/palette";

    .loader-container {
        display: flex;
        align-items: center;
        justify-content: center;
        background: $background-white;

        &.full-screen {
            z-index: 100;
            width: 100vw;
            height: 100vh;
            position: fixed;
        }
    }
</style>
